import { useLocation, useNavigate, Link } from "react-router-dom";

const CATEGORIES = ["U13 Boys", "U15 Boys", "U17 Boys", "Girls"];

function CoachDashboard() {
  const location = useLocation();
  const navigate = useNavigate();
  const teams = location.state?.teams;

  if (!teams || teams.length === 0) {
    return (
      <div className="min-h-screen bg-brand-cream flex items-center justify-center p-4">
        <p className="text-lg">
          Session expired.{" "}
          <Link to="/" className="underline text-brand-red">
            Log in again
          </Link>
        </p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-brand-cream p-4 flex justify-center">
      <div className="w-full max-w-md space-y-3">
        <h1 className="text-xl font-bold text-brand-red">
          Welcome, {teams[0].coachName}
        </h1>
        <p className="text-sm text-gray-600">
          Select a category to register your team.
        </p>

        {CATEGORIES.map((cat) => {
          const t = teams.find((x) => x.category === cat);
          if (!t) return null;
          const paid = t.paymentStatus === "PAID";
          const pending = t.paymentStatus === "PENDING";

          return (
            <div key={cat} className="bg-white rounded-xl shadow p-4 space-y-2">
              <div className="flex justify-between items-center">
                <h2 className="font-bold text-brand-dark">{cat}</h2>
                <span
                  className={`text-xs font-semibold px-2 py-1 rounded-full ${
                    paid
                      ? "bg-green-100 text-green-700"
                      : "bg-orange-100 text-orange-700"
                  }`}
                >
                  {paid
                    ? "Paid"
                    : pending
                      ? "Payment pending"
                      : "Not registered"}
                </span>
              </div>

              <p className="text-sm text-gray-500">
                {paid
                  ? `${t.teamName} - Registration completed`
                  : "Select category and pay to continue"}
              </p>

              <button
                onClick={() =>
                  navigate(paid ? "/dashboard" : "/payment", {
                    state: { team: t },
                  })
                }
                className="w-full bg-brand-red text-white font-bold py-2 rounded-lg hover:bg-red-800"
              >
                {paid ? "Open dashboard" : `Register ${cat}`}
              </button>
            </div>
          );
        })}

        <button
          onClick={() => navigate("/")}
          className="w-full text-sm text-gray-500 underline"
        >
          Log out
        </button>
      </div>
    </div>
  );
}

export default CoachDashboard;